import type { ExperimentClient } from '@amplitude/experiment-js-client';

import {
  getAmplitudeExperimentFlagsStorageKey,
  getAmplitudeExperimentVariantStorageKey,
} from '@/config';

/**
 * Wipes Amplitude SDK variant and flag-config persistence.
 *
 * {@link ExperimentClient.clear} only clears the variant cache (`amp-exp-*`).
 * Local-evaluation flags read from the separate flags cache (`amp-exp-*-flags`),
 * so both must be removed for a full cache-bust when debugging rollout changes.
 */
export const clearAmplitudeExperimentSdkStorage = (
  client: ExperimentClient
): void => {
  client.clear();
  try {
    localStorage.removeItem(getAmplitudeExperimentVariantStorageKey());
    localStorage.removeItem(getAmplitudeExperimentFlagsStorageKey());
  } catch {
    // localStorage may be unavailable
  }
};
